"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReCaptchaVerify = ReCaptchaVerify;
exports.default = void 0;
function ReCaptchaVerify(siteKey, action, callback) {
  window.grecaptcha.ready(function () {
    window.grecaptcha.execute(siteKey, {
      action: action
    }).then(function (token) {
      if (callback) callback(token);
    });
  });
}
var _default = ReCaptchaVerify;
exports.default = _default;